import { network } from 'services/network';

export const getSubProgramPreferenceToggleDate = (subProgramId) => {
    return network.get(`api/bo/getSubProgramPreferenceToggleDate?subProgramId=${subProgramId}`).then((response) => {
        return response.data;
    });
};
